import script from "./SidebarTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarTemplate.vue?vue&type=script&setup=true&lang=js"

import "./SidebarTemplate.vue?vue&type=style&index=0&id=166286c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-166286c9"]])

export default __exports__